export default __webpack_public_path__ + "static/media/management-courses.22ddf3cf.jpg";